import type { FaireProductEntity } from "../../entity_types/product";

export const p_9qgtgq96c8: FaireProductEntity = {
  token: "p_9qgtgq96c8",
  type: "product",
  name: "Sexy Sadie 350ml Natural Shampoo",
  brandToken: "b_12jikkq1",
  brandName: "Routine Natural Beauty",
  imageUrl:
    "https://cdn.faire.com/fastly/f5c3e0baf3f1af2ca2be4c501c562ecc464fd721a0ada51bdbc256a94571c714.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a099933395166cacc41916adc262ba3a181fe83f4422b185cba79b5e08e6cbd1.jpeg",
  ],
  priceDollars: 12,
  description:
    "NATURAL, EASY, LONG HAIR.\nHave effortlessly healthy hair that is shiny, clean & free of build-up, leaving you with hair that grows as quickly as wildflowers.\n\nSWEET, SPICY & CLEANSING\nYlang Ylang, Sweet Orange, Vanilla & Cinnamon.\n\nCOLOUR SAFE | BOTANICALS | VEGAN | REFILLABLE | NO SLS OR PARABENS | NO SYNTHETIC FRAGRANCE\n\nFormulated to be used as a pair with Sexy Sadie Conditioner.\n\nSHAMPOO | BODY WASH | BUBBLE BATH\n\nMade with 100% natural and wholesome ingredients, this shampoo will cleanse your locks while also delivering key nutrients for your longest, healthiest hair.\n\nMADE WILD IN THE WEST.\n\nThese flasks are crafted then printed by local makers, filled at our friendly neighbourhood lab, then shipped from routine HQ. All within a 5 km radius.\n\nAll natural ingredients, better for Mother Nature. Tested on human friends, never animal friends.\n\nThis product is recyclable and, even better, refillable. ",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:55.367Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
